/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */

// Italian (Italiano)
export default {
	'Type something': 'Scrivi qualcosa...',
	Advanced: 'Avanzato',
	'About Jodit': 'A proposito di Jodit',
	'Jodit Editor': 'Jodit Editor',
	"Jodit User's Guide": 'Guida utente di Jodit',
	'contains detailed help for using':
		"contiene una guida dettagliata per l'uso.",
	'For information about the license, please go to our website:':
		'Per informazioni sulla licenza, si prega di visitare il nostro sito web:',
	'Buy full version': 'Acquista la versione completa',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Copyright © XDSoft.net - Chupurnov Valeriy. Tutti i diritti riservati.',
	Anchor: 'Link',
	'Open in new tab': 'Apri in una nuova scheda',
	'Open in fullsize': "Apri l'editor a schermo intero",
	'Clear Formatting': 'Pulisci Formattazione',
	'Fill color or set the text color': 'Colore di sfondo o del testo',
	Redo: 'Ripristina',
	Undo: 'Annulla',
	Bold: 'Grassetto',
	Italic: 'Corsivo',
	'Insert Unordered List': 'Inserisci lista non ordinata',
	'Insert Ordered List': 'Inserisci lista ordinata',
	'Align Center': 'Allinea al centro',
	'Align Justify': 'Allineamento Giustificato',
	'Align Left': 'Allinea a Sinistra',
	'Align Right': 'Allinea a Destra',
	'Insert Horizontal Line': 'Inserisci una linea orizzontale',
	'Insert Image': 'Inserisci immagine',
	'Insert file': 'Inserisci un file',
	'Insert youtube/vimeo video': 'Inserisci video Youtube/Vimeo',
	'Insert link': 'Inserisci link',
	'Font size': 'Dimensione carattere',
	'Font family': 'Tipo di font',
	'Insert format block': 'Inserisci blocco',
	Normal: 'Normale',
	'Heading 1': 'Intestazione 1',
	'Heading 2': 'Intestazione 2',
	'Heading 3': 'Intestazione 3',
	'Heading 4': 'Intestazione 4',
	Quote: 'Citazione',
	Code: 'Codice',
	Insert: 'Inserisci',
	'Insert table': 'Inserisci tabella',
	'Decrease Indent': 'Riduci il rientro',
	'Increase Indent': 'Aumenta il rientro',
	'Select Special Character': 'Seleziona un carattere speciale',
	'Insert Special Character': 'Inserisci un carattere speciale',
	'Paint format': 'Copia formato',
	'Change mode': "Cambia modalita'",
	Margins: 'Margini',
	top: 'su',
	right: 'destra',
	bottom: 'giù',
	left: 'sinistra',
	Styles: 'Stili CSS',
	Classes: 'Classi CSS',
	Align: 'Allinea',
	Right: 'Destra',
	Center: 'Centro',
	Left: 'Sinistra',
	'--Not Set--': '--Non Impostato--',
	Src: 'Fonte',
	Title: 'Titolo',
	Alternative: 'Testo Alternativo',
	Link: 'Link',
	'Open link in new tab': 'Apri il link in una nuova scheda',
	Image: 'Immagine',
	file: 'Archivio',
	'Image properties': "Proprietà dell'immagine",
	Cancel: 'Annulla',
	Ok: 'Accetta',
	'Your code is similar to HTML. Keep as HTML?':
		"Il codice è simile all'HTML. Mantieni come HTML?",
	'Paste as HTML': 'Incolla come HTML',
	Keep: 'Mantieni',
	Clean: 'Pulisci',
	'Insert as Text': 'Inserisci come testo',
	'Word Paste Detected': 'Incolla testo da Word rilevato',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'Il contenuto incollato proviene da un documento Microsoft Word / Excel. Vuoi mantenere il formato o pulirlo?',
	'Insert only Text': 'Inserisci solo il testo',
	'File Browser': 'Cerca file',
	'Error on load list': "Errore durante il caricamento dell'elenco",
	'Error on load folders': 'Errore durante il caricamento delle cartelle',
	'Are you sure?': 'Sei sicuro?',
	'Enter Directory name': 'Inserisci il nome della cartella',
	'Create directory': 'Crea cartella',
	'type name': 'Digita il nome',
	'Drop image': 'Cancella immagine',
	'Drop file': 'Cancella file',
	'or click': 'o clicca',
	'Alternative text': 'Testo alternativo',
	Browse: 'Sfoglia',
	Upload: 'Carica',
	Background: 'Sfondo',
	Text: 'Testo',
	Top: 'Su',
	Middle: 'Centro',
	Bottom: 'Sotto',
	'Insert column before': 'Inserisci la colonna prima',
	'Insert column after': 'Inserisci la colonna dopo',
	'Insert row above': 'Inserisci la riga sopra',
	'Insert row below': 'Inserisci la riga sotto',
	'Delete table': 'Elimina tabella',
	'Delete row': 'Elimina riga',
	'Delete column': 'Elimina colonna',
	'Empty cell': 'Cella vuota',
	Delete: 'Cancella',
	'Strike through': 'Barrato',
	Underline: 'Sottolineato',
	Break: 'Pausa',
	'Search for': 'Cerca per',
	'Replace with': 'Sostituisci con',
	Replace: 'Sostituisci',
	Edit: 'Modifica',
	'Vertical align': 'Allineamento verticala',
	'Horizontal align': 'Allineamento orizzontale',
	Filter: 'Filtro',
	'Sort by changed': 'Ordina per data di modifica',
	'Sort by name': 'Ordina per nome',
	'Sort by size': 'Ordina per dimensione',
	'Add folder': 'Aggiungi cartella',
	Split: 'Dividi',
	'Split vertical': 'Dividi verticalmente',
	'Split horizontal': 'Dividi orizzontale',
	Merge: 'Fondi',
	'Add column': 'Aggiungi colonna',
	'Add row': 'Aggiungi riga',
	Border: 'Bordo',
	'Embed code': 'Includi codice',
	Update: 'Aggiorna',
	superscript: 'indice',
	subscript: 'pedice',
	'Cut selection': 'Taglia selezione',
	Paste: 'Incolla',
	'Choose Content to Paste': 'Seleziona il contenuto da incollare',
	'Chars: %d': 'Caratteri: %d',
	'Words: %d': 'Parole: %d',
	All: 'Tutto',
	'Select %s': 'Seleziona: %s',
	'Select all': 'Seleziona tutto',
	source: 'risorsa',
	bold: 'Grassetto',
	italic: 'Corsivo',
	brush: 'Pennello',
	link: 'Link',
	undo: 'Annulla',
	redo: 'Ripristina',
	table: 'Tabella',
	image: 'Immagine',
	eraser: 'Gomma',
	paragraph: 'Paragrafo',
	fontsize: 'Dimensione del carattere',
	video: 'Video',
	font: 'Font',
	about: 'Approposito di',
	print: 'Stampa',
	underline: 'Sottolineato',
	strikethrough: 'Barrato',
	indent: 'aumenta rientro',
	outdent: 'riduci rientro',
	fullsize: 'espandi',
	shrink: 'comprimi',
	hr: 'linea orizzontale',
	ul: 'lista non ordinata',
	ol: 'lista ordinata',
	cut: 'Taglia',
	selectall: 'Seleziona tutto',
	'Open link': 'Apri link',
	'Edit link': 'Modifica link',
	'No follow': 'Non seguire',
	Unlink: 'Rimuovi link',
	Eye: 'Recensione',
	pencil: 'Per modificare',
	' URL': ' URL',
	Reset: 'Reset',
	Save: 'Salva',
	'Save as ...': 'Salva con nome...',
	Resize: 'Ridimensiona',
	Crop: 'Ritaglia',
	Width: 'Larghezza',
	Height: 'Altezza',
	'Keep Aspect Ratio': 'Mantieni le proporzioni',
	Yes: 'Si',
	No: 'No',
	Remove: 'Rimuovi',
	Select: 'Seleziona',
	'You can only edit your own images. Download this image on the host?':
		'Puoi modificare solo le tue immagini. Vuoi scaricare questa immagine dal server?',
	'The image has been successfully uploaded to the host!':
		"L'immagine è stata caricata correttamente sul server!",
	palette: 'tavolozza',
	'There are no files': 'Non ci sono file in questa directory.',
	Rename: 'Rinomina',
	'Enter new name': 'Inserisci un nuovo nome',
	preview: 'anteprima',
	download: 'Scarica',
	'Paste from clipboard': 'Incolla dagli appunti',
	"Your browser doesn't support direct access to the clipboard.":
		"Il tuo browser non supporta l'accesso diretto agli appunti.",
	'Copy selection': 'Copia selezione',
	copy: 'copia',
	'Border radius': 'Border radius',
	'Show all': 'Mostra tutti',
	Apply: 'Applica',
	'Please fill out this field': 'Si prega di compilare questo campo',
	'Please enter a web address': 'Si prega di inserire un indirizzo web',
	Default: 'Default',
	Circle: 'Cerchio',
	Dot: 'Punto',
	Quadrate: 'Quadrato',
	'Lower Alpha': 'Lettera Minuscola',
	'Lower Greek': 'Lettera Greca Minuscola',
	'Lower Roman': 'Numero Romano Minuscolo',
	'Upper Alpha': 'Lettera Maiuscola',
	'Upper Roman': 'Numero Romano Maiuscolo',
	Find: 'Trova',
	'Find Previous': 'Trova Precedente',
	'Find Next': 'Trova Successivo',
	'Insert className': 'Inserisci il nome della classe',
	'Press Alt for custom resizing':
		'Premere Alt per il ridimensionamento personalizzato',
	'License: %s': 'Licenza: %s'
};
